import { render, staticRenderFns } from "./returnAd.vue?vue&type=template&id=0aa126c2&scoped=true&"
import script from "./returnAd.vue?vue&type=script&lang=js&"
export * from "./returnAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa126c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa126c2')) {
      api.createRecord('0aa126c2', component.options)
    } else {
      api.reload('0aa126c2', component.options)
    }
    module.hot.accept("./returnAd.vue?vue&type=template&id=0aa126c2&scoped=true&", function () {
      api.rerender('0aa126c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/returnAd.vue"
export default component.exports